import QuantityDropdown from "./QuantityDropdown";
import { useCart } from "../../context/CartContext";
import { asset, money } from "../../utils/format";
import { stockMax, onlyOneInStock } from "../../data/catalog";
import { bundleAppliedText } from "../../utils/pricing";

// "2 pc Cherry · Plum" – the choices on this line, minus a generic entry named after the item itself.
function selectionText(row) {
  const items = row.line.items;
  if (!items) return "";
  return Object.entries(items)
    .filter(([name, qty]) => qty > 0 && name !== row.item.name)
    .map(([name, qty]) => (qty > 1 ? `${qty} pc ${name}` : name))
    .join(" · ");
}

export default function CartRow({ row, onEdit }) {
  const { removeItem, setQuantity } = useCart();
  const { item, pieces, total, savings } = row;
  const selections = selectionText(row);
  const saved = savings > 0.005;

  return (
    <div className="row">
      <img
        className="cartEditImg"
        src={asset(item.image)}
        alt={item.name}
        title="Tap to view Product Details."
        role="button"
        tabIndex={0}
        aria-label={`Edit ${item.name} in Product View`}
        onClick={() => onEdit(item.id)}
        onKeyDown={(e) => {
          if (e.key === "Enter" || e.key === " ") {
            e.preventDefault();
            onEdit(item.id);
          }
        }}
      />
      <div>
        <div className="rname">{item.name}</div>
        {onlyOneInStock(item) && <div className="singleStockNote">Only 1 in stock</div>}
        {selections && <div className="cartSimpleVariant">{selections}</div>}
        <div className="cartViewOnlyMeta">Quantity: {pieces}</div>
        {saved && <div className="cartBundleApplied">{bundleAppliedText(item)}</div>}
        {saved && <div className="cartSavings">You save {money(savings)}</div>}
        <div className="cartControls v161Controls">
          <div className="cartQuantityActions">
            <QuantityDropdown value={pieces} max={stockMax(item)} label={`Quantity for ${item.name}`} fixed={Boolean(row.line.items)} onChange={quantity => setQuantity(item, quantity)} />
            {row.line.items && <button type="button" className="cartEditBtn" onClick={() => onEdit(item.id)}>Edit</button>}
          </div>
          <button type="button" className="remove" onClick={() => removeItem(item.id)}>
            Remove
          </button>
        </div>
      </div>
      <div className="cartPrice">
        {saved && <span className="cartRegularTotal">{money(item.price * pieces)}</span>}
        <span className="cartFinalTotal">{money(total)}</span>
      </div>
      <div className="cartImageHint115" aria-hidden="true">
        Tap to view Product Details.
      </div>
    </div>
  );
}
